// VISOR_BUNDLE_VERSION and VISOR_BUNDLE_BASE_URL are injected by webpack.prod.js DefinePlugin.
// Fallbacks below only ever apply to non-production builds (config.es6 / config_noserver.es6
// are used in dev/doc builds), so they intentionally point at the production CDN as a safe default.
const pkg = require("../package.json");
const _visorV = process.env.VISOR_BUNDLE_VERSION || pkg.version;

const cdnBaseUrl =
  process.env.VISOR_BUNDLE_BASE_URL || "https://cloud.aideapro.ai/middlewareblob/common/vf/";
// CDN bundle has a stable filename (overwritten each deploy); query string is the cache buster.
const visorBundleUrl = `${cdnBaseUrl}visor-bundle.js?v=${_visorV}`;

export default {
  // PATHS
  xml_path: "idealStudio/add_xml",
  xml_fake_path: "exercises/ua2_ue10_ejer7.xml",
  exercise_render_template_iframe_src: "./exercises/index.html",
  dist_index: "index.html",
  dist_visor_bundle: process.env.IS_VISOR_BUNDLE
    ? visorBundleUrl
    : `visor-bundle-200-1.js?v=${_visorV}`,
  visor_bundle: process.env.IS_VISOR_BUNDLE ? visorBundleUrl : `visor-bundle-200-1.js?v=${_visorV}`,
  // visor_bundle_scorm: "https://host.elearningsolutions.net/IdealStudioEditor/prod/visor-bundle.min.js",
  visor_bundle_scorm: process.env.IS_VISOR_BUNDLE
    ? visorBundleUrl
    : `visor-bundle-200-1.js?v=${_visorV}`,
  visor_bundle_zip: process.env.IS_VISOR_BUNDLE
    ? visorBundleUrl
    : `visor-bundle-200-1.js?v=${_visorV}`,
  image_placeholder: "./images/placeholder.svg",
  broken_link: "./images/broken_link.png",
  scorm_ejs: "./lib/scorm/scorm_nav.ejs",
  visor_ejs: "./lib/visor/index",
  scorm_zip_2004: "./lib/scorm/scorm2004.zip",
  scorm_zip_12: "./lib/scorm/scorm1.2.zip",
  visor_zip: "./lib/visor/dist.zip",
  export_url: `${process.env.MW_API_URL}api/ideal-studio/training/save-state`,
  import_url: "api/ideal-studio/training/",
  lipsync_url: "api/lipsync/processLipsync",
  search_vish_url: "https://vishub.org/apis/search/",
  // search_vish_url: "http://localhost:3000/apis/search/",
  upload_vish_url: "/IdealStudio/IdealStudioTrainings/PostDeneme",
  profile_vish_url: (id) => `/users/${id}/all_resources.json`,
  includeVishProfile: true,
  defaultAspectRatio: 4 / 3,
  // OPTIONS
  external_providers: {
    enable_search: true,
    enable_external_upload: true,
    enable_catalog_modal: false,
  },
  publish_button: true,
  debug_scorm: false,
  show_numbers_before_navitems: false,
  api_editor_url_change: true,
  open_button_enabled: false,
  sections_have_content: false,
  autosave_time: 0,
  pluginList: [
    // 'EnrichedAudio',
    // 'BasicImage',
    "EnrichedPDF",
    "BasicText",
    "RichText",
    // 'BasicPlayer',
    "DataTable",
    "EnrichedPlayer",
    //"VirtualTour",
    // 'Webpage',
    "HotspotImages",
    // 'ContainerReact',
    "MultipleChoice",
    "MultipleAnswer",
    "FreeResponse",
    // 'InputText',
    // 'ContainerJS',
    "GraficaD3",
    "Ordering",
    "TrueFalse",
    // 'ScormPackage',
    // 'Visor3D',
    // 'FlashObject',
    // 'Rating',
    "AudioCue",
    // 'Google3DPolyObject',
    "DragDrop",
    "Matching",
    "OneClick",
    "AnimationOptions",
    "Shapes",
    "Characters",
    "FillInBlank",
    "HtmlContent",
    "Character",
    "MotionScene",
    "Scene3D",
    "AtomicBoxPlugin",
    "AvatarPlayer",
    "ShapeOverlay",
    "VectorShape",
    "GuideMultiInput",
    "GuideTagDisplay",
    "InteractivePlugin",
    // Değerlendirme Öğeleri → İnteraktif Öğe (AI). Katalogdaki 23 aktivite
    // tipinin HEPSİ bu tek plugin: tipi state taşır, aktiviteyi backend'in
    // ürettiği doküman çizer.
    //
    // Bu listeye eklenmediği için bir süre YALNIZCA prod'da çalışmıyordu:
    // `core/editor/main.es6` NODE_ENV'e göre config seçiyor, yani dev'de
    // (config.es6) kayıtlı olan plugin prod'da yok sayılıyor ve kutu hiç
    // oluşmuyordu. Yeni bir plugin eklerken İKİ listeye birden bakılmalı.
    "InteractiveItem",
  ],
  availableLanguages: ["en", "es", "tr"],
};
